/**
 * 知识库上传
 * @author jayceecai
 */
import React, { FunctionComponent, useMemo, useState, useCallback } from 'react'
import { Card, Table, Button, message } from 'antd'
import { PageHeader, UserAvatar } from '@components'
import { ColumnProps } from 'antd/lib/table'
import { getTableXwidth } from '@configs/table'
import { useTableService } from '@hooks/useTableService'
import { useService } from '@hooks'
import store from '@store'
import KnowledgeModal from './UploadModal'
import { getKnowledgeList, uploadKnowledgeDocument, getSDRIntentionLeadUploadPath } from '@services/knowledge-upload'
import { KnowledgeListParam, KnowledgeItem, KnowledgeUploadParam } from '@types'
import downloadByATag from '../../../library/downloadByATag'
import { cosGetObjectUrl } from '../../../library/cosUtils'
const initFilter: KnowledgeListParam = {
  page: 1,
  pageSize: 10,
}

const KnowledgeUploadPage: FunctionComponent = () => {
  const {
    loading,
    list,
    pagination,
    // setFilter,
    rowKey,
    filter,
    reload,
  } = useTableService(getKnowledgeList, initFilter, '获取知识库文档列表失败')

  // 获取环境相关信息
  const [, pathPrefix, err] = useService(getSDRIntentionLeadUploadPath)
  // console.log('pathPrefix', pathPrefix)

  if (err) {
    message.error(`获取上传路径失败: (${err.message})`)
  }

  const columns: ColumnProps<KnowledgeItem>[] = useMemo(() => [
    {
      title: '知识类型',
      dataIndex: 'type',
      width: 120,
      ellipsis: true,
      render: (value: number) => {
        const titleMap = [
          { label: '话术模版', value: 1 },
          { label: '活动信息', value: 2 },
        ]
        return titleMap.find(item => item.value === value)?.label || value
      },
    },
    { title: '知识标题', dataIndex: 'title', width: 150 },
    { title: '知识描述', dataIndex: 'remark', width: 150, ellipsis: true },
    {
      title: '上传人',
      dataIndex: 'updator',
      width: 200,
      render: value => <div className="text-truncate"><UserAvatar salesName={value?.split('(')[0]} /></div>,
    },
    { title: '上传时间', dataIndex: 'updateTime', width: 150 },
    {
      title: '附件',
      dataIndex: 'fileURL',
      width: 150,
      render: (fileURL: string, record: KnowledgeItem) => {
        if (!fileURL) return ''
        const fileName = pathPrefix?.path && fileURL.startsWith(pathPrefix.path) ? fileURL.slice(pathPrefix.path.length + 1) : fileURL
        return (
          <a
            onClick={async () => {
              const [url, err] = await cosGetObjectUrl(fileURL)
              if (err) {
                message.error(`下载失败: ${err.message}`)
              } else {
                downloadByATag(fileName || '文件', url)
              }
            }}
            style={{ color: '#1890ff' }}
          >
            {fileName}
          </a>
        )
      },
    },
  ], [pathPrefix])
  const tableXWidth = useMemo(() => getTableXwidth(columns), [columns])

  const [showModalForm, setShowModalForm] = useState(false)

  // 打开知识库上传弹窗表单
  const handleApply = async () => {
    setShowModalForm(true)
  }

  // 提交知识库上传表单
  const handleSubmit = useCallback(async (formData: KnowledgeUploadParam) => {
    const [, err] = await uploadKnowledgeDocument(formData)
    if (err) {
      message.error(`知识库上传失败:${err.message}`)
    } else {
      setShowModalForm(false)
      message.success('知识库上传成功')
      reload()
    }
  }, [reload])

  return (
    <>
      <PageHeader
        title="知识库上传"
      />
      <Card className="mt20">
        <Button type="primary" onClick={() => handleApply()}>新增</Button>
        <Table
          className="mt20"
          loading={loading}
          columns={columns}
          dataSource={list}
          pagination={pagination}
          scroll={{ x: tableXWidth }}
          rowKey={rowKey}
        />
      </Card>
      {
        showModalForm && (
          <KnowledgeModal
            visible
            onCancel={() => setShowModalForm(false)}
            onSubmit={handleSubmit}
            pathPrefix={pathPrefix?.path}
          />
        )
      }
    </>
  )
}
export default KnowledgeUploadPage
